export default "<li class=\"breadcrumbs-item\" [class._current]=\"current\"><a [href]=\"link\">{{label}}</a></li>\n";